import { IChecklistItem, ChecklistItemType, ChecklistPhase, getActionRequiredBy } from '@oneethos/shared'
import type { ApplicationState } from '../appContext'

export const selectChecklistItemsState = (state: ApplicationState) => state.checklistItemsConfig

export const selectAllChecklistItems = (state: ApplicationState): IChecklistItem[] =>
  selectChecklistItemsState(state).list ?? []

export const selectChecklistItemsByPhase = (state: ApplicationState, phase: ChecklistPhase): IChecklistItem[] =>
  selectAllChecklistItems(state).filter(item => item.phase === phase).sort((a, b) => (a.sequence) - (b.sequence))

export const selectActionRequiredOwners = (state: ApplicationState, project: any): string[] | undefined => {
  const items = selectAllChecklistItems(state)
  return getActionRequiredBy(items, project)
}

export const selectChecklistItemsByType = (checklistItemsConfig, type: ChecklistItemType, isActive: boolean = false) => {
  return checklistItemsConfig.list?.filter((item:IChecklistItem) => item.type === type && item.active === isActive)
}

export const selectChecklistItemsByLabel = (checklistItemsConfig, label: string): IChecklistItem | undefined => {
  return checklistItemsConfig.list?.find((item: IChecklistItem) => item.label === label)
}
